module.exports = __webpack_public_path__ + "img/logo.d10709c1.png";